import Flex from '@eversports/react-components/primitives/Flex'
import FormatDate from '@eversports/react-components/primitives/FormatDate'
import FormatTime from '@eversports/react-components/primitives/FormatTime'
import Icon, { Icons } from '@eversports/react-components/primitives/Icon'
import Text from '@eversports/react-components/primitives/Text'
import { assertNever } from '@eversports/utility-types'
import React from 'react'

import { Localized } from '../../../localization/react'
import { TimeRange } from '../../../typings/BookableItem'

interface Court {
  type: 'court'
  timeRange: TimeRange
}

interface Event {
  type: 'event'
  timeRanges: Array<TimeRange>
}

type Props = Court | Event

const SingleTimeBlock: React.FC<React.PropsWithChildren<TimeRange>> = ({ start, end }) => (
  <Flex>
    <Icon icon={Icons.CALENDAR} color="subtleText" marginRight="dense" />
    <Text fontWeight="bold" size="small">
      <Localized
        id="single-time-block"
        params={{
          date: <FormatDate value={start} variant="long" />,
          startTime: <FormatTime value={start} variant="short" />,
          endTime: <FormatTime value={end} variant="short" />,
        }}
      />
    </Text>
  </Flex>
)

const BookingDetailsTimeBlock: React.FC<React.PropsWithChildren<Props>> = (props) => {
  switch (props.type) {
    case 'court':
      return <SingleTimeBlock {...props.timeRange} />
    case 'event':
      const { timeRanges } = props

      // If it is a single event
      if (timeRanges.length === 1) {
        return <SingleTimeBlock {...timeRanges[0]} />
      }

      // If it's a multi session event, but all events are on the same day
      const isMultiSessionOnSameDay = timeRanges[0].start === timeRanges[timeRanges.length - 1].start

      return (
        <Flex>
          <Icon icon={Icons.CALENDAR} color="subtleText" marginRight="dense" />
          <Text fontWeight="bold" size="small">
            {!isMultiSessionOnSameDay ? (
              <Localized
                id="multi-session-event"
                params={{
                  startDate: <FormatDate value={timeRanges[0].start} variant="long" />,
                  endDate: <FormatDate value={timeRanges[timeRanges.length - 1].start} variant="long" />,
                  numberOfEvents: timeRanges.length,
                }}
              />
            ) : (
              <FormatDate value={timeRanges[0].start} variant="long" />
            )}
          </Text>
        </Flex>
      )

    default:
      return assertNever(props)
  }
}

export default BookingDetailsTimeBlock
